import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';

import CustomSelect from 'components/filters/CustomSelect';
import Icon from 'components/Icon';

import styles from './styles.module.scss';

const {
	publicRuntimeConfig: { assetPrefix }
} = getConfig();

const RegionsCard = ({ federalSubjects }) => {
	const [region, setRegion] = useState();

	const regionButtonRef = useRef(null);

	const choiceRegion = (name, selectedValue) => {
		setRegion(selectedValue);

		if (selectedValue) {
			setTimeout(() => {
				regionButtonRef.current.focus();
			}, 0);
		}
	};

	const redirectOnRegionPage = () => {
		if (region !== '') {
			window.open(`/region/${region}`, '_blank');
		}
	};

	return (
		<div
			className={styles.RegionsCard}
			style={{
				backgroundImage: `url("${assetPrefix}images/catalogs/regions.jpg")`
			}}
		>
			<div className={styles.RegionsCard__Title}>Регионы России</div>
			<div className={styles.RegionsCard__Subtitle}>
				Выберите регион, чтобы узнать о его культурных событиях и интересных
				местах
			</div>
			<div className={styles.RegionsCard__Control}>
				<CustomSelect
					name="federalSubjects"
					options={federalSubjects}
					resetOption={{ title: 'Выберите регион', name: '' }}
					buttonTheme="classicField"
					onChange={choiceRegion}
					selectedValue={region}
					searchable
					ariaLabelButton="Выберите регион, чтобы узнать о его культурных событиях и интересных местах"
				/>
				<button
					className={styles.RegionsCard__Button}
					type="button"
					title="Открыть регион в новой вкладке"
					onClick={redirectOnRegionPage}
					ref={regionButtonRef}
					disabled={!region}
				>
					<Icon
						icon="chevronRightRounded"
						className={styles.RegionsCard__Icon}
						aria-hidden="true"
					/>
				</button>
			</div>
		</div>
	);
};

RegionsCard.propTypes = {
	federalSubjects: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			title: PropTypes.string
		})
	)
};

export default RegionsCard;
